
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class LhcOrderTable extends Vue {
    //六合彩下单
    table = {
        data: [],
        column: [
            {
                key: 'qihao',
                title: '期号',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).qihao
                    return h('span', str)
                }
            },
            {
                key: 'status',
                title: '订单状态',
                align: 'center',
                render: (h, params) => {
                    let arr = ['待派奖', '中奖', '未中奖', '不派奖']
                    let str = arr[JSON.parse(params.row.opt_detail).status - 1]
                    return h('span', str)
                }
            },
            {
                key: 'orderid',
                title: '订单号',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).orderid
                    return h('span', str)
                }
            },
            {
                key: 'tz_count',
                title: '投注总注数',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).tz_count
                    return h('span', str)
                }
            },
            {
                key: 'tz_point',
                title: '投注总金额',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).tz_point)
                    return h('span', str)
                }
            },
            {
                key: 'order_time',
                title: '下单时间',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).order_time
                    return h('span', str)
                }
            },
            {
                key: 'subType',
                title: '投注方式',
                align: 'center',
                render: (h, params) => {
                    let obj = JSON.parse(params.row.opt_detail).tz_info
                    let str = this.subgamename(JSON.parse(obj)[0].subType)
                    return h('span', str)
                }
            },
            {
                key: 'tzhm',
                title: '投注号码',
                align: 'center',
                render: (h, params) => {
                    let obj = JSON.parse(params.row.opt_detail).tz_info
                    let str = JSON.parse(obj)[0].tzhm
                    return h('span', str)
                }
            },
            {
                key: 'tzhm',
                title: '赔率',
                align: 'center',
                render: (h, params) => {
                    let obj = JSON.parse(params.row.opt_detail).tz_info
                    let str = JSON.parse(obj)[0].odds['1']
                    return h('span', str)
                }
            }
        ]
    }
    //六合彩子玩法
    subgamename(num) {
        let arr = ['特码直选', '两面', '正码任选', '正1特', '正1两面', '正2特', '正2两面', '正3特', '正3两面', '正4特', '正4两面', '正5特', '正5两面', '正6特', '正6两面', '三全中', '三中二', '二全中', '二中特', '特串', '特码半波', '特肖', '一肖', '二连肖', '三连肖', '四连肖', '总肖', '正肖', '合肖中', '合肖不中', '特码头尾', '二连尾', '三连尾', '四连尾', '五不中', '六不中', '七不中', '八不中', '九不中', '十不中', '七色波']
        return arr[num - 1]
    }

    @Prop()
    listdata
}
